import React from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { messages } from './messages';
import styles from './styles.module.less';

/**
 * @param {object} props
 * @param {string} [props.className]
 * @returns {JSX.Element}
 */
export const DangerousGoodsTag = ({ className = '' }) => {
  return (
    <div className={classnames(styles['dangerous-goods-tag'], className)}>
      <FormattedMessage {...messages.dangerousGoods} />
    </div>
  );
};
